module.exports = __webpack_public_path__ + "img/bg-login-3.dd49a8f6.jpg";